// extracted by mini-css-extract-plugin
module.exports = {"priceHistory":"PriceHistory_priceHistory__uCbUe","content":"PriceHistory_content__tFSSi","title":"PriceHistory_title__idbG_","price":"PriceHistory_price__0080a"};